export type CarouselItem = {
  title: string;
  /** Short body copy under the title (portfolio: maps from `description` in locale JSON). */
  label: string;
  /** Optional meta line, e.g. role · stack (from `meta` in portfolio.json). */
  meta?: string;
  /** Public URL path (e.g. `/images/foo.webp`). */
  image_url?: string;
  /** Optional @2x version of the image for high-DPI screens. */
  image_url_2x?: string;
  /** Optional link for the card. */
  url?: string;
  target?: string;
  rel?: string;
  /** If true, show hover button that opens a detail modal. */
  hasOverlay?: boolean;
  /** Optional long description for overlay modal body. */
  description_long?: string;
  /** If true, item has a dedicated portfolio section page. */
  hasPageSlug?: boolean;
  /** Slug for the portfolio section route (e.g. `web`). */
  pageSlug?: string;
  /** Parent section slug for `/portfolio/[section]/[slug]` detail URLs. */
  sectionSlug?: string;
};

export const CAROUSEL_ITEMS: CarouselItem[] = [
  { title: 'Sample card 1', label: 'Placeholder imagery / copy.' },
  { title: 'Sample card 2', label: 'Placeholder imagery / copy.' },
  { title: 'Sample card 3', label: 'Placeholder imagery / copy.' },
  { title: 'Sample card 4', label: 'Placeholder imagery / copy.' },
  { title: 'Sample card 5', label: 'Placeholder imagery / copy.' },
  { title: 'Sample card 6', label: 'Placeholder imagery / copy.' },
  { title: 'Sample card 7', label: 'Placeholder imagery / copy.' },
  { title: 'Sample card 8', label: 'Placeholder imagery / copy.' },
];

export const CAROUSEL_STORY_ITEMS: CarouselItem[] = Array.from({ length: 6 }).map((_, i) => ({
  title: `Card ${i + 1}`,
  label: `Label ${i + 1}`,
}));
